import Vue from 'vue'
import VueRouter from 'vue-router'
// https://github.com/declandewet/vue-meta
import VueMeta from 'vue-meta'
// Adds a loading bar at the top during page loads.
import NProgress from 'nprogress/nprogress'
import store from '@state/store'
import { allRoutes } from './routes'

if (process.env.NODE_ENV === 'production') {
  require('@src/app.config')
} else {
  require('@src/app.config.dev')
}

Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})

const router = new VueRouter({
  routes: allRoutes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// router.beforeResolve((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     let user;
//     Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(data => {
//       if (data && data.signInUserSession) {
//         user = data;
//       }
//       next()
//     }).catch((e) => {
//       next({
//         path: '/',
//         query: {
//           redirect: to.fullPath,
//         }
//       });
//     });
//   }
//   next()
// })

// router.beforeResolve(async (to, from, next) => {
//
//   let allowed = true
//   const requiredUserGroups = to.meta.requiresUserGroups || []
//
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     try {
//       const caUser = await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
//       const caGroups = caUser.signInUserSession.idToken.payload["cognito:groups"] || []
//       if (caGroups.length === 0 && requiredUserGroups.length > 0) allowed = false
//       if (requiredUserGroups.length > 0
//           && !requiredUserGroups.some(group => caGroups.includes(group)))  {
//         allowed = false
//       }
//     } catch (e) {
//       next({
//         path: "/",
//         query: {
//           redirect: to.fullPath
//         }
//       })
//     }
//   }
//   if (allowed) {
//     next()
//   } else {
//     next({
//       path: "/404",
//     })
//   }
// })

router.beforeResolve(async (to, from, next) => {

  let allowed = false
  const requiredUserGroups = to.meta.requiresUserGroups || []

  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      const caUser = await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
      const caGroups = caUser.signInUserSession.idToken.payload["cognito:groups"] || []

      if (requiredUserGroups.length === 0) allowed = true
      if (requiredUserGroups.length > 0 && caGroups.length > 0 &&
          requiredUserGroups.some(group => caGroups.includes(group))) allowed = true

    } catch (e) {
      next({
        path: "/",
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    allowed = true
  }
  if (allowed) {
    next()
  } else {
    next({
      path: "/404",
    })
  }
})

// router.beforeResolve(async (to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     try {
//       await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
//       next();
//     } catch (e) {
//       next({
//         path: "/",
//         query: {
//           redirect: to
//         }
//       })
//     }
//   }
// })

// Before each route evaluates...
// router.beforeEach((routeTo, routeFrom, next) => {

//   // If this isn't an initial page load...
//   // if (routeFrom.name !== null) {
//   //   // Start the route progress bar.
//   //   NProgress.start()
//   // }
//   // console.log('routeTo', routeTo)
//   // console.log('routeFrom', routeFrom)
//   if (process.env.NODE_ENV === 'development') return next()
  
//   const authRequired = routeTo.matched.some((route) => route.meta.authRequired)
//   if (!authRequired) return next()

//   const idToken = localStorage.getItem('idToken');
//   // console.log('id token from index', idToken)

//   if (idToken ===  undefined || idToken === null || idToken === '') {
//     // redirectToLogin()

//     // window.location = appConfig.AWS.cognitoLoginUI
//     // return next('/login');
//     // return next({ name: 'noauth', query: { redirectFrom: routeTo.fullPath } })
//     return next({ name: 'noauth'})


//   }  // console.log('process.env.NODE_ENV', process.env.NODE_ENV)
//   // if (store.state.token_ts + store.state.expires_in <= parseInt(Date. now() / 1000) ) {
//   //   let baseURL = appConfig.AWS.oauth2TokenURL || ""

//   //   const params = new URLSearchParams()
//   //   params.append('grant_type', 'refresh_token')
//   //   params.append('client_id', appConfig.AWS.appClientID)
//   //   params.append('refresh_token', store.state.refresh_token);

//   //   let headers = {
//   //     "Content-Type": "application/x-www-form-urlencoded",
//   //     "Authorization": appConfig.AWS.authorization
//   //   }
//   //   axios.post(baseURL, params, { headers: headers } ).then((response) => {
//   //     console.log(response.data)
//   //     if (response.status === 200) {
//   //       store.state.id_token = response.data.id_token
//   //       store.state.access_token = response.data.access_token
//   //       store.state.refresh_token = response.data.refresh_token
//   //       store.state.expires_in = response.data.expires_in
//   //       store.state.token_type = response.data.token_type
//   //       store.state.token_ts = parseInt(Date. now() / 1000)
//   //     }
//   //   })
//   // }

//   // if (store.state.id_token == null) window.location = appConfig.AWS.cognitoLoginUI 
//   //'https://coronamdr.auth.us-east-1.amazoncognito.com/login?client_id=2s20vu48l0bih6dpcuuncohg0p&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=http://localhost:8080/oauth2/login';
//   // console.log("store.getters['auth/loggedIn']", store.getters['auth/loggedIn'])

//   // if (store.getters['auth/loggedIn']) {
//   //   // Validate the local user token...
//   //   return store.dispatch('auth/validate').then((validUser) => {
//   //     // Then continue if the token still represents a valid user,
//   //     // otherwise redirect to login.
//   //     validUser ? next() : redirectToLogin()
//   //   })
//   // }

//   return next()
//   // Check if auth is required on this route
//   // (including nested routes).
//   // const authRequired = routeTo.matched.some((route) => route.meta.authRequired)
//   // // If auth isn't required for the route, just continue.
//   // if (!authRequired) return next()

//   // // If auth is required and the user is logged in...
//   // if (store.getters['auth/loggedIn']) {
//   //   // Validate the local user token...
//   //   return store.dispatch('auth/validate').then((validUser) => {
//   //     // Then continue if the token still represents a valid user,
//   //     // otherwise redirect to login.
//   //     validUser ? next() : redirectToLogin()
//   //   })
//   // }


//   // If auth is required and the user is NOT currently logged in,
//   // redirect to login.
//   // redirectToLogin()

//   function redirectToLogin() {
//     // Pass the original route to the login component
//     next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
//   }
// })


// // Before each route evaluates...
// router.beforeEach((routeTo, routeFrom, next) => {
//   // If this isn't an initial page load...
//   if (routeFrom.name !== null) {
//     // Start the route progress bar.
//     NProgress.start()
//   }

//   // Check if auth is required on this route
//   // (including nested routes).
//   const authRequired = routeTo.matched.some((route) => route.meta.authRequired)

//   // If auth isn't required for the route, just continue.
//   if (!authRequired) return next()

//   // If auth is required and the user is logged in...
//   if (store.getters['auth/loggedIn']) {
//     // Validate the local user token...
//     return store.dispatch('auth/validate').then((validUser) => {
//       // Then continue if the token still represents a valid user,
//       // otherwise redirect to login.
//       validUser ? next() : redirectToLogin()
//     })
//   }

//   // If auth is required and the user is NOT currently logged in,
//   // redirect to login.
//   redirectToLogin()

//   function redirectToLogin() {
//     // Pass the original route to the login component
//     // next({ name: 'login', query: { redirectFrom: routeTo.fullPath } })
//   }
// })

// router.beforeResolve(async (routeTo, routeFrom, next) => {
//   // Create a `beforeResolve` hook, which fires whenever
//   // `beforeRouteEnter` and `beforeRouteUpdate` would. This
//   // allows us to ensure data is fetched even when params change,
//   // but the resolved route does not. We put it in `meta` to
//   // indicate that it's a hook we created, rather than part of
//   // Vue Router (yet?).
//   try {
//     // For each matched route...
//     for (const route of routeTo.matched) {
//       await new Promise((resolve, reject) => {
//         // If a `beforeResolve` hook is defined, call it with
//         // the same arguments as the `beforeEnter` hook.
//         if (route.meta && route.meta.beforeResolve) {
//           route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
//             // If the user chose to redirect...
//             if (args.length) {
//               // If redirecting to the same route we're coming from...
//               if (routeFrom.name === args[0].name) {
//                 // Complete the animation of the route progress bar.
//                 NProgress.done()
//               }
//               // Complete the redirect.
//               next(...args)
//               reject(new Error('Redirected'))
//             } else {
//               resolve()
//             }
//           })
//         } else {
//           // Otherwise, continue resolving the route.
//           resolve()
//         }
//       })
//     }
//     // If a `beforeResolve` hook chose to redirect, just return.
//   } catch (error) {
//     return
//   }

//   // If we reach this point, continue resolving the route.
//   next()
// })

// // When each route is finished evaluating...
// router.afterEach((routeTo, routeFrom) => {
//   // Complete the animation of the route progress bar.
//   NProgress.done()
// })

export default router
